import React, { useState } from "react";
import axios from "axios";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);
    setLoading(true);

    try {
      const response = await axios.post("https://solanthegroup.com/admin/api/newsletter", { email });
      setMessage({ type: "success", text: response.data.message });
      setEmail("");
    } catch (error) {
      setMessage({
        type: "error",
        text: error.response?.data?.message || "Something went wrong!",
      });
    }

    setLoading(false);
  };

  return (
    <div>
      <div className="subscribe-area subscribe-style-1">
        <div className="subscribe-inner">
          <div className="title">Subscribe to Newsletter</div>
          {message && (
            <div className={`alert ${message.type === "success" ? "alert-success" : "alert-danger"}`}>
              {message.text}
            </div>
          )}
          <form onSubmit={handleSubmit} className="newsletter-form-1 mt--40">
            <input
              type="email"
              placeholder="Your Email"
              required
              value={email}
              onChange={handleChange}
            />
            <button type="submit" className="tmp-btn btn-primary" disabled={loading}>
              {loading ? "Subscribing..." : "Subscribe Now "}
              <i className="fa-sharp fa-regular fa-paper-plane" />
            </button>
          </form>
        </div>   
      </div>
      <style>{`
        @media only screen and (max-width: 767px) {
          .newsletter-form-1 input{
          padding: 10px !important;
          }
        }

      `}</style>
    </div>
  );
}
